import getTooltipFormatter from 'src/components/Charts/tooltipResolver';
import { round } from '../../../../../util/numbers/rounder';
import { PIE } from '../../../types';
import { toEchartData } from '../dataProcessor';
import legendTooltipFormatter from './legendTooltipFormatter';
import { capitalizeText } from 'src/util/formatters/stringNormalizer';

/**
 * converte os resultados gerais passados (data)
 * para a option do echarts.
 * @param {*} data resultados gerais
 * @param {*} theme tema atual, é utilizado para definir
 * cores das legendas, barras, fonte, etc.
 */
export default function toEchartOption(data, theme, chartFontSize = 14, disabledLegends = [], highlitIndex) {
  /**
   * parsing to intermediary data structure
   * it will extract, from data, legends and series.
   */
  const echartData = toEchartData(data);
  let echartDataWithStyle = echartData.data;

  // Aplica o efeito de highlited item.
  if (highlitIndex > -1) {
    echartDataWithStyle = echartDataWithStyle.map((item, index) => ({
      ...item,
      ...(highlitIndex === undefined ? {} : {
        itemStyle: index === highlitIndex ? {
          borderType: theme.highlitedItemBorderType,
          borderColor: theme.highlitedItemBorderColor,
          borderWidth: theme.highlitedItemBorderWidth,
        } : null,
      }),
    }));
  };

  // Considera o caso em que existem consolidações
  const formatter = getTooltipFormatter(data, PIE);

  const legendsWithIcon = echartData.legends.map((legend) => ({
    name: legend,
    icon: 'circle',
    enabled: true,
  }));

  const selectedLegends = {};
  legendsWithIcon.forEach(({ name }) => {
    const enabled = !disabledLegends.includes(name);

    selectedLegends[name] = enabled;
  });

  const label = {
    show: true,
    formatter: (params) => (`${round(params.value, 1)}%`),
    textStyle: {
      fontSize: chartFontSize,
      color: theme.label.text,
    },
  };

  return {
    animationDuration: 0,
    color: theme.colors,
    visibleLegends: legendsWithIcon,
    tooltip: {
      show: true,
      trigger: 'item',
      formatter,
    },
    legend: {
      selected: selectedLegends,
      tooltip: {
        show: true,
        trigger: 'item',
        formatter: legendTooltipFormatter(echartDataWithStyle, disabledLegends, formatter),
      },
      orient: 'horizontal',
      x: 'left',
      data: legendsWithIcon,
      type: 'scroll',
      textStyle: {
        width: '10%',
        color: theme.legend.color,
        fontSize: chartFontSize,
        fontFamily: 'Roboto, sans-serif'
      },
      formatter: capitalizeText,
      pageTextStyle: {
        color: theme.legend.pagination.text.color,
      },
      pageIconColor: theme.legend.pagination.buttons.color,
    },
    series: [
      {
        type: 'pie',
        radius: ['50%', '70%'],
        avoidLabelOverlap: true,
        label,
        labelLine: {
          show: true,
          lineStyle: {
            color: theme.label.line,
          },
        },
        minShowLabelAngle: 5,
        data: echartDataWithStyle,
      },
    ],
  };
}
